import { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";

const useStyles = makeStyles({
	btn: {
		display: "inline-flex",
		alignItems: "center",
		justifyContent: "center",
		marginLeft: 6,
		marginTop: 4,
		padding: "4px 8px",
		borderRadius: 8,
		border: "1px solid var(--surface-border)",
		background: "#fff",
		color: "var(--color-muted)",
		fontFamily: "var(--font-sans)",
		fontSize: 11,
		fontWeight: 600,
		cursor: "pointer",
		lineHeight: 1,
		transition: "color 0.15s ease, border-color 0.15s ease, background 0.15s ease",
		"&:hover": {
			color: "var(--active-brand-color)",
			borderColor: "var(--active-brand-color)",
			background: "var(--color-alt-grey)",
		},
		"&:focus-visible": {
			outline: "2px solid var(--active-brand-color)",
			outlineOffset: 2,
		},
	},
	copied: {
		color: "var(--bot-status-connected)",
		borderColor: "rgba(22, 163, 74, 0.35)",
	},
});

function htmlToPlainText(html) {
	if (!html) return "";
	const el = document.createElement("div");
	el.innerHTML = String(html).replace(/\\"/g, '"');
	return (el.textContent || el.innerText || "").trim();
}

export default function CopyMessageButton({ text, html }) {
	const classes = useStyles();
	const [copied, setCopied] = useState(false);

	const handleCopy = async () => {
		const plain = text != null ? String(text).trim() : htmlToPlainText(html);
		if (!plain) return;
		try {
			await navigator.clipboard.writeText(plain);
			setCopied(true);
			setTimeout(() => setCopied(false), 1600);
		} catch (e) {
			// Fallback for older browsers / insecure contexts
			const ta = document.createElement("textarea");
			ta.value = plain;
			ta.setAttribute("readonly", "");
			ta.style.position = "absolute";
			ta.style.left = "-9999px";
			document.body.appendChild(ta);
			ta.select();
			document.execCommand("copy");
			document.body.removeChild(ta);
			setCopied(true);
			setTimeout(() => setCopied(false), 1600);
		}
	};

	return (
		<Tooltip title={copied ? "Copied" : "Copy message"}>
			<button
				type="button"
				className={`${classes.btn} ${copied ? classes.copied : ""}`}
				onClick={handleCopy}
				aria-label={copied ? "Message copied" : "Copy message"}
			>
				{copied ? "Copied" : "Copy"}
			</button>
		</Tooltip>
	);
}
